import FormField from "@/components/forms/FormField";

const SELECT_CLASS =
  "h-11 w-full rounded-lg border border-input bg-card px-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

export function FormError({ message }) {
  if (!message) return null;
  return <p role="alert" className="text-sm text-destructive">{message}</p>;
}

export function tierPriceDollars(tiers, tier) {
  const match = tiers.find((t) => t.value === tier);
  return match ? String(match.price_cents / 100) : "";
}

/**
 * Plan, price paid, and payment note inputs for recording a prepaid
 * campaign plan. Picking a tier resets the price to that tier's list
 * price. Expects useForm data with `tier`, `price_dollars`, and `notes`.
 */
export default function CampaignPlanFields({ idPrefix, tiers, data, setData }) {
  return (
    <div className="space-y-4">
      <FormField name={`${idPrefix}-tier`} label="Plan">
        <select
          id={`${idPrefix}-tier`}
          value={data.tier}
          onChange={(e) => setData({ ...data, tier: e.target.value, price_dollars: tierPriceDollars(tiers, e.target.value) })}
          className={SELECT_CLASS}
        >
          {tiers.map((tier) => (
            <option key={tier.value} value={tier.value}>{tier.label}</option>
          ))}
        </select>
      </FormField>
      <FormField
        name={`${idPrefix}-price`}
        label="Price paid (CAD)"
        type="number"
        min="0"
        step="0.01"
        value={data.price_dollars}
        onChange={(e) => setData("price_dollars", e.target.value)}
      />
      <FormField
        name={`${idPrefix}-notes`}
        label="Payment note (optional)"
        placeholder="e-Transfer reference, cheque number…"
        value={data.notes}
        onChange={(e) => setData("notes", e.target.value)}
      />
    </div>
  );
}
